import React, { Component } from "react";
import Header from "./Header/Header";
import { Notify } from "react-redux-notify";
import AuthFooter from "./Footer/AuthFooter";

class CMSLayout extends Component {
  componentDidMount() {
    document.title = "Rebel | The Home of Bahamian Creators";
  }
  state = {};
  render() {
    return (
      <div>
        <Notify position="TopRight" />
        <div>
          <Header bgcolor="yes" />
          {React.cloneElement(this.props.children)}
          <AuthFooter bgcolor="yes" />
        </div>
      </div>
    );
  }
}

export default CMSLayout;
